<template>
    <div class="cus-field" :class="'cus-field-' + type" :style="{backgroundColor: wrapBackground}">
        <textarea
                :disabled="disabled"
                v-if="type === 'textarea'"
                class="cus-field__control"
                :placeholder="placeholder"
                ref="input"
                :rows="rows"
                @blur="blur"
                :cols="cols"
                @input="onInput"
                :value="value"
                :style="inputStyle"
        ></textarea>

        <!--搜索框-->
        <template v-else-if="type === 'search'">
            <div class="cus-field-search__wrap" :style="{backgroundColor: inputBackground}">
                <van-icon class="left-icon" name="search" color="#7b7b7b" size="0.53rem"></van-icon>
                <input
                        :disabled="disabled"
                        class="cus-field__control"
                        :placeholder="placeholder"
                        ref="input"
                        @input="onInput"
                        :value="value"
                        :style="inputStyle"
                />
                <van-icon class="right-icon" v-show="value.length>0" name="close" color="#7b7b7b" size="0.53rem" @click="onClear"></van-icon>
            </div>
            <span class="cus-field__btn" v-if="showAction" @click="handleActionClick">搜索</span>
        </template>

        <!--输入框-->
        <template v-else>
            <label v-show="label" :style="{...labelStyle, flexBasis: labelWidth}" class="cus-field__label">{{label}}</label>
            <input
                    class="cus-field__control"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    ref="input"
                    @blur="blur"
                    @input="onInput"
                    :maxlength="maxLength"
                    :value="value"
                    :type="type"
                    :style="inputStyle"
            />
            <span class="slot-right">
                <slot name="right"></slot>
            </span>
        </template>
    </div>
</template>

<script>
    import {isDef} from "../utils";
    export default {
        name: "Field",
        props: {
            value: {
                type: [String, Number],
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            labelWidth: {
                type: String,
                default: '2.8rem'
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: '请输入'
            },
            showAction: {
                type: Boolean,
                default: false
            },
            wrapBackground: {
                type: String,
                default: '#fff'
            },
            inputBackground: {
                type: String,
                default: '#fff'
            },
            rows: {
                type: String,
                default: '2'
            },
            cols: String,
            maxLength: {
                type: Number
            },
            disabled: {
                type: Boolean,
                default: false
            },
            inputStyle: {
                type: Object,
                default: () => {return {}}
            },
            labelStyle: {
                type: Object,
                default: () => {return {}}
            }
        },
        methods: {
            format(target = this.$refs.input) {
                let {value} = target
                const {maxlength} = this.$attrs

                if (this.type === 'number' && isDef(maxlength) && value.length > maxlength) {
                    value = value.slice(0, maxlength);
                    target.value = value;
                }
                return value
            },
            onInput(e) {
                this.$emit('input', this.format(e.target))
            },
            handleActionClick() {
                this.$emit('search', this.value)
            },
            onClear() {
                this.$emit('input', '')
                this.$emit('clear')
                this.$refs.input.focus()
            },
            blur(){
                this.$emit("blurs")
            }
        }
    }
</script>

<style lang="scss">
    .cus-field {
        box-sizing: border-box;
        display: flex;
        color: #000;
        font-size: 0.41rem;
        height: 1.33rem;
        line-height: 1.33rem;
        padding: 0 0.33rem;
        background-color: #fff;

        &-textarea {
            height: unset;
            line-height: unset;
            padding: 0.41rem 0.33rem;
        }

        &:not(:last-child) {
            border-bottom: 1px solid #e5e5e5;
        }

        &__control {
            width: 100%;
            border: 0;
            margin: 0;
            padding: 0;
            resize: none;
            font-size: 0.4rem;
            color: #4F4F4F;
            background-color: transparent;

            &:disabled {
                background-color: #fff;
            }

            &::-webkit-input-placeholder {
                color: #8F8F8F;
            }
        }

        & ~ .cus-field {
            box-sizing: border-box;
            border-top: 1px solid #e5e5e5;
        }

        /* 搜索 */
        &-search {
            padding: 0.2rem 0.6rem;
            height: unset;
            &__wrap {
                position: relative;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                border-radius: 8px;
                overflow: hidden;
                padding: 0 0.3rem;
            }

            .cus-field__control {
                height: 0.93rem;
                &::-webkit-input-placeholder {
                    color: #8f8f8f;
                    text-align: center;
                }
            }

            .cus-field__btn {
                white-space: nowrap;
                font-size: 0.4rem;
                height: 0.93rem;
                line-height: 0.93rem;
                padding-left: 0.6rem;
                color: #FE9329;
            }
        }

        .slot-right {
            white-space: nowrap;
        }
    }
</style>
